const ClubhouseValidationService = () => ({
  handleSync: ({ iterationsData, doSync, sensorAuth }) => {
    if (!iterationsData.length) doSync(sensorAuth);
  },
  isSyncPerEntity: false
});

export default ClubhouseValidationService;
